/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { randomPostAnswerbookAsk } from "../../funcs/randomPostAnswerbookAsk.js";
import { PostAnswerbookAskRequest$zodSchema } from "../../models/postanswerbookaskop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostAnswerbookAskRequest$zodSchema,
};

export const tool$randomPostAnswerbookAsk: ToolDefinition<typeof args> = {
  name: "random-post-answerbook-ask",
  description: `答案之书 (POST)

通过POST请求向答案之书提问并获得神秘答案。

## 功能概述
与GET方式相同，但通过JSON请求体发送问题，适合在需要发送较长问题或希望避免URL编码问题的场景中使用。

## 请求体格式
请求体必须是有效的JSON格式，包含question字段。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await randomPostAnswerbookAsk(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
